import Vue from "vue";
import Router from "vue-router";
import VueSignaturePad from "vue-signature-pad";
import store from "../store";

import pageRoutes from "../modules/pages/router";
import loginRoutes from "../modules/login/router";
import registrationRoutes from "../modules/registration/router";
import jobSeekerRoutes from "../modules/jobseeker/router";
import dashboardRoutes from "../modules/dashboard/router";
import surveyRoutes from "../modules/survey/router";
import sgaQuestionnaireRoutes from "../modules/sga-questionnaire/router";
import agencyRoutes from "../modules/agencies/router";
import apprenticeRoutes from "../modules/apprentice/router";
import publicProfileRoutes from "../modules/publicprofile/router";
import skillspassportRoutes from "../modules/skillspassport/router";
import wioachecklist from "../modules/wioa/router";
import registrationquestionnaire from "../modules/registration-questionnaire/router";

import userAuthentication from "../mixins/userAuthentication";

Vue.use(Router);
Vue.use(VueSignaturePad);

const baseRoutes = [
  {
    path: "*",
    redirect: {
      name: "/",
    },
  },
];

const routes = baseRoutes.concat(
  pageRoutes,
  loginRoutes,
  registrationRoutes,
  jobSeekerRoutes,
  dashboardRoutes,
  surveyRoutes,
  sgaQuestionnaireRoutes,
  agencyRoutes,
  apprenticeRoutes,
  publicProfileRoutes,
  skillspassportRoutes,
  wioachecklist,
  registrationquestionnaire
);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL, // not working process variable
  routes,
});

router.beforeEach((to, from, next) => {

  // All routes in the Private build require an organisation.
  let userLoginPromise = null;
  let userRolePromise = null;

  // // Make sure the jobseeker/apprentice is set. (not working)
  // if (!store.state.apprentice.current_organisation && !store.state.apprentice.current_organisation) {
  //   const redirectUrl = process.env.VUE_APP_PUBLIC_BASE_URL;
  //   window.location = redirectUrl;
  //   return;
  // }

  // // All routes require login except for those which have allowGuest.
  // if (to.meta.allowGuest == undefined && !store.state.apprentice.current_user) {
  //   userLoginPromise = Promise.reject(false);
  // } else {
  //   userLoginPromise = Promise.resolve(true);
  // }
  const anyHaveRoles =
    to.matched.filter((m) => m && m.meta && m.meta.requiredRole).length > 0;

  if (anyHaveRoles) {
    const allRolesSatasfied = to.matched.every((m) => {
      if (!m.meta) return true;
      if (!m.meta.requiredRole) return true;
      return (
        userAuthentication.methods.userHasRole(m.meta.requiredRole) ||
        userAuthentication.methods.userHasRole(
          process.env.VUE_APP_ROLE_SUPER_ADMIN
        )
      );
    });

    if (allRolesSatasfied) {
      userRolePromise = Promise.resolve(true);
    } else {
      userRolePromise = Promise.reject(false);
    }
  } else {
    userRolePromise = Promise.resolve(true);
  }

  // Handle the promises.

  Promise.all([userLoginPromise, userRolePromise])
    .then(() => {
      next();
    })
    .catch(() => {
      window.location.redirect = window.location.host;
    });
});

export default router;
